






import { Component, Vue, Prop, Emit } from "vue-property-decorator";
import SidebarNavItem from "./SidebarNavItem.vue";
import SidebarNavLink from "./SidebarNavLink.vue";

@Component({
  components: {
    SidebarNavItem,
    SidebarNavLink
  }
})
export default class SidebarNavLabel extends Vue {
  @Prop({ default: "" })
  public name: string;

  @Prop({ default: "" })
  public url: string;

  @Prop({ default: "" })
  public icon: string;

  @Prop({ default: "" })
  public classes: string;

  @Prop()
  public label: any;

  @Emit()
  public getClasses(classes: string) {
    return classes ? classes.split(" ") : [];
  }

  get classList() {
    const classes = {
      navItem: ["hidden-cn", ...this.getClasses(this.classes)].join(" "),
      navLink: "nav-label",
      icon: [
        this.icon ? this.icon : "fa fa-circle",
        this.label.variant ? `text-${this.label.variant}` : "",
        this.label.class ? this.label.class : ""
      ].join(" ")
    };
    return classes;
  }
}
